import axios from 'axios';

const service = 'https://feidriver.fieldenvironmental.com';

export const getDrivers = () => {
    return new Promise((resolve, reject) => {
        axios.get(`${service}/drivers_data`).then(res => {
            resolve(res.data);
        }).catch(err => {
            console.error(err.message);
            reject(err);
        });
    });    
}

export const getUser = (email) => {
    return new Promise((resolve, reject) => {
        axios.get(`${service}/user/${email}`).then(res => {
            resolve(res.data);
        }).catch(err => {
            console.error(err.message);
            reject(err);
        });
    });    
}

export const getActiveDrivers = () => {
    return new Promise((resolve, reject) => {
        axios.get(`${service}/drivers/active`).then(res => {
            resolve(res.data);
        }).catch(err => {
            console.error(err.message);
            reject(err);
        });
    });    
}

export const getInactiveDrivers = () => {
    return new Promise((resolve, reject) => {
        axios.get(`${service}/drivers/inactive`).then(res => {
            resolve(res.data);
        }).catch(err => {
            console.error(err.message);
            reject(err);
        });
    });    
}

export const getDriverCoords = (email) => {
    return new Promise((resolve, reject) => {
        axios.get(`${service}/driver/coords/${email}`).then(res => {
            resolve(res.data);
        }).catch(err => {
            console.error(err.message);
            reject(err);
        });
    });    
}

export const getDeliveries = (currentDate) => {
    return new Promise((resolve, reject) => {
        axios.get(`${service}/deliveries`, {params: { date: currentDate }}).then(res => {
            resolve(res.data);
        }).catch(err => {
            console.error(err.message);
            reject(err);
        });
    });    
}

export const getPickups = (currentDate) => {
    return new Promise((resolve, reject) => {
        axios.get(`${service}/pickups`, {params: { date: currentDate }}).then(res => {
            resolve(res.data);
        }).catch(err => {
            console.error(err.message);
            reject(err);
        });
    });    
}

export const addDriver = (driver) => {
    return new Promise((resolve, reject) => {
        axios.post(`${service}/driver/add`, { driver }).then(res => {
            resolve(driver);
        }).catch(err => {
            console.error(err.message);
            reject(err);
        });
    });    
}

export const assignTasks = (driver, admin, modifiedTasks, date) => {
    return new Promise((resolve, reject) => {
        axios.post(`${service}/driver/tasks`, { driver, admin, modifiedTasks, date: date ? date.format('YYYY-MM-DD 00:00:00.000') : null }).then(res => {
            resolve(res.data);
        }).catch(err => {
            console.error(err.message);
            reject(err);
        });
    });    
}

export const assignTask = (driver, admin, task) => {
    return new Promise((resolve, reject) => {
        axios.post(`${service}/driver/task`, { driver, admin, task }).then(res => {
            resolve(res.data);
        }).catch(err => {
            console.error(err.message);
            reject(err);
        });
    });    
}

export const getDirections = (tasks, coords, shipFrom) => {
    return new Promise((resolve, reject) => {
        axios.post(`${service}/waypoints/`, {tasks, coords, shipFrom}).then(res => {
            resolve(res.data);
        }).catch(err => {
            console.error(err.message);
            reject(err);
        });
    });      
}